
import Vue from 'vue'
import { store } from '@/store.js'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

import { createApp} from 'vue'

import App from './App.vue';
import router from './router';
import VueLoading from 'vue-loading-overlay';
import VueMatomo from 'vue-matomo';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { createVuetify } from 'vuetify'
import TextClamp from 'vue3-text-clamp'

export default
    createVuetify({
      icons: {
            defaultSet: 'mdi',
            aliases,
            sets: {
              mdi,
            }
      },
  })

// Vuetify
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/dist/vuetify.min.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
const vuetify = createVuetify({components,directives});

const app = createApp(App);

//app.config.errorHandler = (error) => ErrorService.onError(error);
app.config.errorHandler = (err, instance, info) => {
  //console.error('Global Error Handler:', err);
  console.log(err)
  console.info('In Component Instance:', instance);
  console.info('Error Info:', info);

  if (err.message.includes('NS_ERROR_NOT_AVAILABLE')) {
    // Handle 3DMol.js-specific errors
    //instance.$data.showErrorMessage = false; // Example: Show a UI message
  }

  // Handle the error gracefully and prevent app from crashing
};


app.use(VueMatomo, {
    host: "https://mtb.bioinf.med.uni-goettingen.de/matomo",
    siteId: 4,
    router: router,
    enableLinkTracking: true,
    trackInitialView: true,
    debug: true,
});
  
app.use(router)
app.use(store)
app.use(VueLoading)
app.use(vuetify)
app.use(TextClamp)

app.mount('#app')
window._paq.push(['trackPageView']);



